<app-page [onlyContent]="true" [showBottomBar]="false" [simpleTopBar]="globalVars.isMobile()" title="Sell an NFT">
  <sell-nft-modal></sell-nft-modal>
</app-page>
